import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

type LazyModule = { default: ComponentType };

const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error);
  return /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(message);
};

export const lazyWithRetry = (
  importer: () => Promise<LazyModule>,
  routeKey: string,
): LazyExoticComponent<ComponentType> => lazy(async () => {
  const retryKey = `aura:route-chunk-retry:${routeKey}`;

  try {
    const loadedModule = await importer();
    sessionStorage.removeItem(retryKey);
    return loadedModule;
  } catch (error) {
    if (isChunkLoadError(error) && sessionStorage.getItem(retryKey) !== '1') {
      sessionStorage.setItem(retryKey, '1');
      window.location.reload();

      // Keep Suspense mounted until the browser begins the reload.
      return new Promise<never>(() => undefined);
    }

    throw error;
  }
});
